import { icons } from "./icons";

export const menu = [
    {
        linkName: 'Dashboard',
        slug: '/',
        icons: icons.dashbord
    },
    {
        linkName: 'Assets',
        slug: '/assets',
        icons: icons.assets
    },
    {
        linkName: 'Booking',
        slug: '/booking',
        icons: icons.booking
    },
    {
        linkName: 'Sell Cars',
        slug: '/sellCars',
        icons: icons.sallCars
    },
    {
        linkName: 'Services',
        slug: '/services',
        icons: icons.servise
    },
    {
        linkName: 'Calendar',
        slug: '/calendar',
        icons: icons.calendar
    }

]